import React, { useState, useEffect } from "react";
import useSettings from "../../../../hooks/settings";
import { Settings } from "../../../../models/settings_model";
import { IconButton } from "../../common/buttons";
import {
  getPosAlertsEnabled,
  setPosAlertsEnabled,
} from "../../../notifications/OnlineOrderAlert";

const Sales: React.FC = () => {
  const [settings, saveSettings] = useSettings();
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    return () => {
      if (updated) {
        window.location.reload();
      }
    };
  }, [updated]);

  const updateSetting = (ev: { currentTarget: HTMLButtonElement }) => {
    const setting_type = ev.currentTarget.id as keyof Settings;
    const checked = !settings[setting_type];
    saveSettings(setting_type, checked);
    setUpdated(true);
  };

  const posAddClient = settings.pos_add_client || "disabled";
  const [posAlertsOn, setPosAlertsOn] = useState(getPosAlertsEnabled);

  return (
    <div className="row justify-content-center mt-3">
      <div className="col-md-7">
        <div className="card">
          <div className="card-body ">
            <h3 className="">Reportes de Ventas</h3>
            <p>
              Tu sistema en Foo para Empresas te puede ayudar a saber de mejor
              manera cuánto estás ganando realmente con el uso de servicios
              adicionales.
            </p>
            <div className="form-group row mx-auto">
              <label
                htmlFor="input_terminal"
                className="col-sm-3 col-htmlForm-label"
              >
                Terminal
              </label>
              <div className="col-sm-3">
                <input
                  type="tel"
                  className="form-control service_val"
                  id="input_terminal"
                  data-service="terminal"
                  placeholder="comisión"
                  value="3.60"
                />
                <span className="feedback_input text-muted">%</span>
              </div>
            </div>
            <button type="button" className="btn btn-success btn-block mt-4">
              Guardar
            </button>
          </div>{" "}
        </div>
      </div>
      <div className="col">
        <h3 className="">Otras Opciones</h3>
        <IconButton
          clickFun={updateSetting}
          text="Marcar pedido listo al cobrar"
          classes="btn-sm"
          checked={settings.avoid_fulfilled === true ? undefined : "true"}
          id="avoid_fulfilled"
        />
        <IconButton
          clickFun={updateSetting}
          text="Cobros a un click"
          classes="btn-sm"
          checked={settings.quick_charge === true ? undefined : "true"}
          id="quick_charge"
        />
        <IconButton
          clickFun={updateSetting}
          text="Mostar tipo de tarjeta al cobrar"
          classes="btn-sm"
          checked={settings.cards_type === true ? "true" : undefined}
          id="cards_type"
        />
        <IconButton
          clickFun={updateSetting}
          text="Pantalla de bloqueo"
          classes="btn-sm"
          checked={settings.lock_screen !== false ? "true" : undefined}
          id="lock_screen"
        />
        <IconButton
          clickFun={updateSetting}
          text="Permitir múltiples órdenes por mesa"
          classes="btn-sm"
          checked={settings.multi_table_orders === true ? "true" : undefined}
          id="multi_table_orders"
        />
        <IconButton
          clickFun={() => {
            const next = !posAlertsOn;
            setPosAlertsEnabled(next);
            setPosAlertsOn(next);
          }}
          text="Notificaciones de nuevas órdenes POS"
          classes="btn-sm"
          checked={posAlertsOn ? "true" : undefined}
          id="pos_order_alerts"
        />
        <p className="text-muted small ml-4 pl-2 mt-n1">
          Los pedidos en línea siempre muestran notificación.
        </p>
        <hr />
        <h5>Agregar Cliente en POS</h5>
        <p className="text-muted small">
          Solicitar datos del cliente al crear un pedido en el punto de venta.
        </p>
        <div className="btn-group-vertical w-100" role="group">
          <button
            className={`btn btn-outline-dark text-left ${
              posAddClient === "disabled" ? "active" : ""
            }`}
            onClick={() => { saveSettings("pos_add_client", "disabled"); setUpdated(true); }}
          >
            <i
              className={`far ${
                posAddClient === "disabled"
                  ? "fa-check-circle"
                  : "fa-circle"
              } mr-2`}
            />
            No solicitar cliente
          </button>
          <button
            className={`btn btn-outline-dark text-left ${
              posAddClient === "always" ? "active" : ""
            }`}
            onClick={() => { saveSettings("pos_add_client", "always"); setUpdated(true); }}
          >
            <i
              className={`far ${
                posAddClient === "always"
                  ? "fa-check-circle"
                  : "fa-circle"
              } mr-2`}
            />
            Siempre solicitar cliente
          </button>
          <button
            className={`btn btn-outline-dark text-left ${
              posAddClient === "pickup" ? "active" : ""
            }`}
            onClick={() => { saveSettings("pos_add_client", "pickup"); setUpdated(true); }}
          >
            <i
              className={`far ${
                posAddClient === "pickup"
                  ? "fa-check-circle"
                  : "fa-circle"
              } mr-2`}
            />
            Solo en pedidos para recoger
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sales;
